export function getObjectFields(object, fields) {
  return Object.fromEntries(fields.map(field => [field, object[field]]))
}